/**
 * Clean a raw caller ID into a plain phone number.
 * Plivo/SIP callers arrive as e.g. "919880471549@phone.plivo.com" or
 * "sip:+14155551234@phone.plivo.com" — strip the SIP scheme + everything after
 * "@" so only the number (with a leading + when present) is shown/used.
 */
export function normalizePhone(raw) {
    if (!raw) return "";
    let s = String(raw).trim();
    if (s.includes("@")) s = s.split("@")[0];
    s = s.replace(/^sips?:/i, "").trim();
    const hasPlus = s.startsWith("+");
    const digits = s.replace(/[^0-9]/g, "");
    if (!digits) return String(raw).trim();
    return (hasPlus ? "+" : "") + digits;
}
